import { Badge } from "reactstrap";
import { LI, UL } from "../../../../AbstractElements";
import { LayoutTypeProp } from "../../../../Type/CustomizerType";
import CommonUL from "../../Common/CommonUL";

const LTR = ({ handleLayout, layout_type }: LayoutTypeProp) => {
  return (
    <LI
      className={`${layout_type === "ltr" ? "active" : ""}`}
      data-attr="ltr"
      onClick={() => {
        handleLayout("ltr");
      }}>
      <div className="header bg-light">
        <CommonUL />
      </div>
      <div className="body">
        <UL className="simple-list d-flex flex-row">
          <LI className="bg-light sidebar"></LI>
          <LI className="bg-light body">
            <Badge color="primary">LTR</Badge>
          </LI>
        </UL>
      </div>
    </LI>
  );
};

export default LTR;